module.exports = __webpack_public_path__ + "static/media/linkedin.6aa0ef1b.png";